import { createRoute, redirect } from "@tanstack/solid-router";
import { appRoute } from "./route";

/**
 * Home de MealPlan: el planificador semanal es el centro del producto
 * (PRODUCT_PLAN.md — principio rector). El dashboard de todos del template
 * quedó desmontado de la navegación.
 */
export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  beforeLoad: ({ params }) => {
    // oxlint-disable-next-line no-throw-literal
    throw redirect({ to: "/u/$u/planner", params: { u: params.u } });
  },
});
